module.exports = __webpack_public_path__ + "img/sceneIcon2-1.d54d455f.png";